import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';
import { Career } from '../models/career.model';
import { CareerService } from '../../services/career.service';
import { DateFormatPipe } from '../../date-format.pipe';
import { SafeTextPipe } from '../../safe-text.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

interface JobDuty {
  duty: string;
}

interface JobCompetency {
  competency: string;
}

interface Location {
  location: string;
}

interface CareerDetail {
  careerId: number;
  title: string;
  locations: Location[];
  closedDate: string;
  jobDuties: JobDuty[];
  competencies: JobCompetency[]
}

@Component({
  selector: 'app-career-detail',
  standalone: true,
  imports: [NgIf, DateFormatPipe, SafeTextPipe, TranslateModule],
  templateUrl: './career-detail.component.html',
  styleUrl: './career-detail.component.css'
})
export class CareerDetailComponent {

  careerId: number = 0;
  selectedCareer: Career | null = null;
  
  baseApiUrl = environment.baseApiUrl;

  constructor(private route: ActivatedRoute, private careerService: CareerService, private translate: TranslateService) {}

  isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.careerId = Number(params.get('id'));
      if (!isNaN(this.careerId)) {
        this.getCareerById(this.careerId);
      } else {
        console.error('Invalid careerId');
      }
    })
  }

 
  getCareerById(careerId: number): void {
    this.careerService.getCareerById(careerId).subscribe({
      next: (career: Career) => {
        this.selectedCareer = career;
      },
      error: (error) => {
        console.error('Error fetching career details: ', error);
      }
    })
  }

  // careers: CareerDetail[] = [
  //   {
  //     careerId: 1, 
  //     title: 'SME Relationship Manager (02)',
  //     locations: [
  //       {
  //         location: 'Head Office'
  //       }
  //     ],
  //     closedDate: '15 December 2024',
  //     jobDuties: [
  //       {
  //         duty: 'Conduct marketing and sales promotions to the target clients and partners'
  //       },
  //       {
  //         duty: 'Grow SME loans as a target through building strong and meaningful relationships with prospects and clients networking and providing superior customer services to the clients'
  //       },
  //       {
  //         duty: 'Supervise and work closely with the field staff at the branches related to high-profile client onboarding'
  //       },
  //       {
  //         duty: 'Keep close eyes on and track competitor intelligence'
  //       },
  //       {
  //         duty: 'Build good relationships with customers and local authorities'
  //       },
  //       {
  //         duty: 'Ensure compliance at all times – process, policy, and working instruction'
  //       },
  //       {
  //         duty: 'Constitute ideas and suggestions for improvement and success'
  //       },
  //       {
  //         duty: 'Achieve daily/weekly/monthly/yearly targets'
  //       },
  //       {
  //         duty: 'Another task/project assigned by SUM/OSM'
  //       }
  //     ],
  //     competencies: [
  //       {
  //         competency: 'University degree in Sales and Marketing, Finance and Banking or related field.'
  //       },
  //       {
  //         competency: 'Minimum 2-3 years of working experience in SME loan products.'
  //       },
  //       {
  //         competency: 'Analytical and problem-solving abilities to understand client needs and recommend suitable solutions.'
  //       },
  //       {
  //         competency: 'Proven ability to achieve sales targets.'
  //       },
  //       {
  //         competency: 'Creative, dynamic, flexible, self-direct and self-motivated team player.'
  //       },
  //       {
  //         competency: 'Good communication and interpersonal skills.'
  //       },
  //       {
  //         competency: 'Computer literacy.'
  //       },
  //       {
  //         competency: 'Good English communication both writing and speaking'
  //       }
  //     ]
  //   },
  //   {
  //     careerId: 2, 
  //     title: 'Chief Credit Officer (01)',
  //     locations: [
  //       {
  //         location: 'Siem Reap Provincial Branch'
  //       }
  //     ],
  //     closedDate: '15 December 2024',
  //     jobDuties: [
  //       {
  //         duty: 'Supervise the team on daily implementation of PoA of the Branch including promotion, loan assessment, validation, and monitoring;'
  //       },
  //       {
  //         duty: 'Regularly check the daily activities of S/COs and monitor their productivity to discover their weaknesses toward improvement;'
  //       },
  //       {
  //         duty: 'Regularly coach, train and build S/COs’ competencies to make sure they all have good understanding of their role and responsibilities in accordance with policies, procedures, instructions, administration, especially the selling techniquesand quality client recruitment;'
  //       },
  //       {
  //         duty: 'Regularly check on Cashier and Teller performance to make sure the accounting records are accurate and on time. Guide and advice Cashier and Teller in implementing their daily duties and responsibilities;'
  //       },
  //       {
  //         duty: 'Check the client loan utilization (100%) and recommend the finding to ensure no irregular and expected risk occur;'
  //       },
  //       {
  //         duty: 'Evaluate the performance of S/COs on a semi-annual and annual basis and report to BM;'
  //       },
  //       {
  //         duty: 'Participate and lead sales promotion and sales activities for the Institution’s products/ services to target clients and check the readiness, quality and tactics of their sales promotion;'
  //       },
  //       {
  //         duty: 'Conduct field research and assign S/COs to research on client’s satisfaction survey, SWOT analysis of the Institution’s competitors and report to BM with the proposed strategies and changes;'
  //       },
  //       {
  //         duty: 'Propose initiative and positive strategies and tactics for quality management and high productivities to BM;'
  //       },
  //       {
  //         duty: 'Build business disciplines and the Institution’s representative with the staff to communicate the Institution’s identity with clients, authorities, partners and other stakeholders;'
  //       },
  //       {
  //         duty: 'Review, assess and approve loans according to the delegated authority;'
  //       },
  //       {
  //         duty: 'Perform others task as may be assigned by the BM;'
  //       }
  //     ],
  //     competencies: [
  //       {
  //         competency: 'Bachelor degree in finance and banking, accounting, or business management'
  //       },
  //       {
  //         competency: 'At least 1 year of experience in the related field'
  //       },
  //       {
  //         competency: 'Good command in English and Khmer'
  //       },
  //       {
  //         competency: 'Computer literacy such as MS office, MS outlook, internet and emails'
  //       },
  //       {
  //         competency: 'Good interpersonal communication skill, team work and conflict management resolution and ability to work under pressure'
  //       },
  //       {
  //         competency: 'Be independent, result-oriented, integrity and accountability'
  //       },
  //       {
  //         competency: 'High ability in effective problem-solving by showing good problem-solving negotiation in different level of situations'
  //       },
  //       {
  //         competency: 'High commitment to work and willing to frequently travel to places across provinces/cities to chase up partners’/clients’ overdue loan.'
  //       }
  //     ]
  //   },
  //   {
  //     careerId: 3, 
  //     title: 'Branch Manager (02)',
  //     locations: [
  //       {
  //         location: 'Kampong Thom & Kampong Cham'
  //       }
  //     ],
  //     closedDate: '15 December 2024',
  //     jobDuties: [
  //       {
  //         duty: 'Lead and manage the operational activities to achieve branch’s targets'
  //       },
  //       {
  //         duty: 'Coordinate all branch staffs to prepare a Plan of Action (PoA)'
  //       },
  //       {
  //         duty: 'Ensure all branch staffs are effectively carrying out their duties and responsibilities including the implementation of their PoA'
  //       },
  //       {
  //         duty: 'Evaluate staff performance on a semi-annual and annual basis and report to the Operations & Strategy Manager (OSM)'
  //       },
  //       {
  //         duty: 'Guide and advise all branch staffs on time management'
  //       },
  //       {
  //         duty: 'Check daily staff attendance and advice regarding the Institution’s office hours requirement'
  //       },
  //       {
  //         duty: 'Conduct regular spot checks on S/CO’s performance including their competency in planning, monitoring and interacting with clients and stakeholders'
  //       },
  //       {
  //         duty: 'Conduct regular spot checks on Cashier’s performance to ensure that the accounting records are accurate and timely prepared'
  //       },
  //       {
  //         duty: 'Motivate branch staffs to improve their performance'
  //       },
  //       {
  //         duty: 'Conduct field research and/or assign field staffs to conduct research on client satisfaction, and SWOT analysis of the Institution’s competitors'
  //       },
  //       {
  //         duty: 'Organize monthly meetings including staff trainings on existing and new policies and instructions to ensure correct implementation'
  //       },
  //       {
  //         duty: 'Ensure accuracy of and approve the daily transaction reports prepared by Cashier'
  //       },
  //       {
  //         duty: 'Monitor and update the branch’s inventories on a regular basis'
  //       },
  //       {
  //         duty: 'Promote the Institution’s business to publics'
  //       },
  //       {
  //         duty: 'Represent the Institution in performing public relations and communications within the designated areas and'
  //       },
  //       {
  //         duty: 'Perform other tasks as may be assigned by the OSM or other HoDs.'
  //       }
  //     ],
  //     competencies: [
  //       {
  //         competency: 'Bachelor’s or Master’s Degree in Finance and Banking or related field'
  //       },
  //       {
  //         competency: 'Minimum 3 year-experiences in banking sector'
  //       },
  //       {
  //         competency: 'Good numerical skills and understanding of data analysis/statistical methods'
  //       },
  //       {
  //         competency: 'Good knowledge of MS Office and databases'
  //       },
  //       {
  //         competency: 'Outstanding communication skills'
  //       },
  //       {
  //         competency: 'Great attention to detail and a result driven approach'
  //       },
  //       {
  //         competency: 'Excellent organizational and leadership abilities'
  //       },
  //       {
  //         competency: 'Reliable and Trustworthy'
  //       },
  //       {
  //         competency: 'Murderable verbal and written communication skills in English.'
  //       }
  //     ]
  //   },
  //   {
  //     careerId: 4, 
  //     title: 'មន្ត្រីឥណទានជាន់ខ្ពស់ (១០)',
  //     locations: [
  //       {
  //         location: 'សាខាខេត្តកណ្តាល (អង្គស្នួល)'
  //       },
  //       {
  //         location: 'សាខាខេត្តកំពង់ស្ពឺ​'
  //       },
  //       {
  //         location: 'សាខាស្រុកកំពង់ត្រាច'
  //       },
  //       {
  //         location: 'សាខាស្រុកបន្ទាយមាស'
  //       },
  //       {
  //         location: 'សាខាខេត្តតាកែវ (ស្រុកត្រាំកក់)'
  //       },
  //       {
  //         location: 'សាខាខេត្តព្រៃវែង (ស្រុកកំពង់ត្របែក)'
  //       },
  //       {
  //         location: 'សាខាក្រុងបាវិត​ (ផ្សារជីភូ)'
  //       },
  //       {
  //         location: 'សាខាច្បារអំពៅ'
  //       },
  //       {
  //         location: 'សាខាខណ្ឌបឹងកេងកង'
  //       }
  //     ],
  //     closedDate: '១៥ ធ្នូ ២០២៤',
  //     jobDuties: [
  //       {
  //         duty: 'រៀបចំនិងអនុវត្តផែនការសកម្មភាព និងប្រកាន់ខ្ជាប់នូវគោលការណ៍និងនីតិវិធីឥណទានរបស់គ្រឹះស្ថាន។'
  //       },
  //       {
  //         duty: 'រៀបចំផែនការការងារប្រចាំសប្តាហ៍ និងប្រចាំខែ រួមទាំងមានការប្រមូលសំណង។'
  //       },
  //       {
  //         duty: 'កសាងបណ្តាញជាមួយអាជ្ញាធរមូលដ្ឋានមានដូចជា៖ មេភូមិ មេឃុំ មេប៉ុស្តិ៍​ និងប្រតិបត្តិករ​មីក្រូហិរញ្ញវត្ថុផ្សេងទៀតនៅតាមតំបន់នានា។'
  //       },
  //       {
  //         duty: 'ផ្សព្វផ្សាយផលិតផលនិងសេវាកម្មរបស់ស្ថាប័នដើម្បីកំណត់គោលដៅអតិថិជននៅតំបន់សក្តានុពល។​ ជួបអតិថិជនសក្តានុពលនិងវាយតម្លៃពាក្យសុំកម្ចីប្រាក់របស់ពួកគេដោយអនុលោមតាមគោលការណ៍និងនីតិវិធីឥណទានរបស់គ្រឹះស្ថាន។'
  //       },
  //       {
  //         duty: 'ត្រូវបា្រកដថា ១០០% នៃការប្រើប្រាស់ប្រាក់កម្ចីរបស់អតិថិជនពិតជាត្រឹមត្រូវតាមគោលបំណង។'
  //       },
  //       {
  //         duty: 'ចាត់វិធានការជាបន្ទាន់នៅពេលមានការកើតឡើងនៃប្រាក់កម្ចីយឺតយ៉ាវ និងជូនដំណឹងទៅប្រធានក្រុម។ និងប្រធានសាខាដើម្បីអន្តរាគមន៍។'
  //       },
  //       {
  //         duty: 'ប្រឹក្សា និងផ្តល់យោបល់ ចែករំលែកព័ត៌មានដល់អតិថិជនក្នុងការធ្វើអាជីវកម្មនិងគាំទ្រអាជីវកម្មរបស់ពួកគាត់។'
  //       },
  //       {
  //         duty: 'ធ្វើការស្រាវជ្រាវលើការស្ទង់មតិអំពីការពេញចិត្តរបស់អតិថិជន វិភាគចំណុចខ្លាំង និងចំណុចខ្សោយរបស់ដៃគូប្រកួតប្រជែងនៅក្នុងតំបន់ប្រតិបត្តិការ ហើយផ្ញើរបាយការទៅប្រធានក្រុម និងប្រធានសាខាដើម្បើចងក្រងនិងចាត់ចែងបន្ត។'
  //       },
  //       {
  //         duty: 'រៀបចំរបាយការប្រចាំខែដែលតម្រូវដោយប្រធានក្រុម និងប្រធានសាខា។'
  //       },
  //       {
  //         duty: 'ផ្សព្វផ្សាយ និងចូលរួមសកម្មភាពសង្គមដូចជា ឥណទានផ្សារភ្ជាប់និងការអប់រំ សុខភាព និងការការពារបរិស្ថាន ព្រមទាំងជួយប្រឹក្សាយោបល់បង្កើនមុខរបររបស់អតិថិជនតាមរយៈគំរូអជីវកម្មល្អ និងជោគជ័យ។'
  //       },
  //       {
  //         duty: 'បំពេញកិច្ចការងារផ្សេងៗទៀតត្រូវបានកំណត់ដោយ ប្រធានក្រុមមន្រ្តីឥណទាន ឬក៏ប្រធានសាខា។'
  //       }
  //     ],
  //     competencies: [
  //       {
  //         competency: 'បានប្រឡងជាប់សញ្ញាបត្របាក់ឌុប ឬបរិញ្ញាបត្រកាន់តែប្រសើរ។'
  //       },
  //       {
  //         competency: 'មានបទពិសោធន៍យ៉ាងតិច ២ឆ្នាំទាក់ទងនឹងវិស័យធនាគារ ឬមីក្រូហិរញ្ញវត្ថុ។'
  //       },
  //       {
  //         competency: 'ពូកែខាងគណិតវិទ្យា និងមានជំនាញគណនាល្អ។'
  //       },
  //       {
  //         competency: 'មានជំនាញក្នុងការផ្តល់សេវាកម្មល្អ ការទំនាក់ទំនងល្អ និងការដោះស្រាយបញ្ហា។'
  //       },
  //       {
  //         competency: 'មានសីលធម៌ល្អ មានឥរិយាបថល្អ មានភាពស្មោះត្រង់ មានការប្តេជ្ញាចិត្តខ្ពស់ មានការគោរពវិន័យ និងអាចធ្វើការជាក្រុមបាន។'
  //       },
  //       {
  //         competency: 'អាចធ្វើការក្រោមសម្ពាធបាន។'
  //       },
  //       {
  //         competency: 'មានឆន្ទៈក្នុងការរៀនអ្វីដែលថ្មីៗ និងរៀនឆាប់រហ័ស។'
  //       }
  //     ]
  //   },
  //   {
  //     careerId: 5, 
  //     title: 'មន្ត្រីឥណទាន (១០)',
  //     locations: [
  //       {
  //         location: 'សាខាខេត្តកណ្តាល (អង្គស្នួល)'
  //       },
  //       {
  //         location: 'សាខាខេត្តកំពង់ស្ពឺ​'
  //       },
  //       {
  //         location: 'សាខាស្រុកកំពង់ត្រាច'
  //       },
  //       {
  //         location: 'សាខាស្រុកបន្ទាយមាស'
  //       },
  //       {
  //         location: 'សាខាខេត្តតាកែវ (ស្រុកត្រាំកក់)'
  //       },
  //       {
  //         location: 'សាខាខេត្តព្រៃវែង (ស្រុកកំពង់ត្របែក)'
  //       },
  //       {
  //         location: 'សាខាក្រុងបាវិត​ (ផ្សារជីភូ)'
  //       },
  //       {
  //         location: 'សាខាច្បារអំពៅ'
  //       },
  //       {
  //         location: 'សាខាខណ្ឌបឹងកេងកង'
  //       }
  //     ],
  //     closedDate: '១៥ ធ្នូ ២០២៤',
  //     jobDuties: [
  //       {
  //         duty: 'រៀបចំនិងអនុវត្តផែនការសកម្មភាព និងប្រកាន់ខ្ជាប់នូវគោលការណ៍និងនីតិវិធីឥណទានរបស់គ្រឹះស្ថាន។'
  //       },
  //       {
  //         duty: 'រៀបចំផែនការការងារប្រចាំសប្តាហ៍ និងប្រចាំខែ រួមទាំងមានការប្រមូលសំណង។'
  //       },
  //       {
  //         duty: 'កសាងបណ្តាញជាមួយអាជ្ញាធរមូលដ្ឋានមានដូចជា៖ មេភូមិ មេឃុំ មេប៉ុស្តិ៍​ និងប្រតិបត្តិករ​មីក្រូហិរញ្ញវត្ថុផ្សេងទៀតនៅតាមតំបន់នានា។'
  //       },
  //       {
  //         duty: 'ផ្សព្វផ្សាយផលិតផលនិងសេវាកម្មរបស់ស្ថាប័នដើម្បីកំណត់គោលដៅអតិថិជននៅតំបន់សក្តានុពល។​ ជួបអតិថិជនសក្តានុពលនិងវាយតម្លៃពាក្យសុំកម្ចីប្រាក់របស់ពួកគេដោយអនុលោមតាមគោលការណ៍និងនីតិវិធីឥណទានរបស់គ្រឹះស្ថាន។'
  //       },
  //       {
  //         duty: 'ជួបអតិថិជនសក្តានុពល និងវាយតម្លៃពាក្យសុំកម្ចីប្រាក់របស់ពួកគេដោយអនុលោមតាមគោលការណ៍ និងនីតិវិធី ឥណទានរបស់គ្រឹះស្ថាន។'
  //       },
  //       {
  //         duty: 'ធានាឲ្យប្រាដកថា ១០០% នៃការប្រើប្រាស់ប្រាក់កម្ចីរបស់អតិថិជនឱ្យត្រឹមត្រូវតាមគោលបំណង។'
  //       },
  //       {
  //         duty: 'ចាត់វិធានការជាបន្ទាន់នៅពេលមានការកើតឡើងនៃប្រាក់កម្ចីយឺតយ៉ាវ និងជូនដំណឹងទៅប្រធានក្រុម។ និងប្រធានសាខាដើម្បីអន្តរាគមន៍។'
  //       },
  //       {
  //         duty: 'ប្រឹក្សា និងផ្តល់យោបល់ ចែករំលែកព័ត៌មានដល់អតិថិជនក្នុងការធ្វើអាជីវកម្មនិងគាំទ្រអាជីវកម្មរបស់ពួកគាត់។'
  //       },
  //       {
  //         duty: 'ធ្វើការស្រាវជ្រាវលើការស្ទង់មតិអំពីការពេញចិត្តរបស់អតិថិជន វិភាគចំណុចខ្លាំង និងចំណុចខ្សោយរបស់ដៃគូប្រកួតប្រជែងនៅក្នុងតំបន់ប្រតិបត្តិការ ហើយផ្ញើរបាយការទៅប្រធានក្រុម និងប្រធានសាខាដើម្បើចងក្រងនិងចាត់ចែងបន្ត។'
  //       },
  //       {
  //         duty: 'រៀបចំរបាយការប្រចាំខែដែលតម្រូវដោយប្រធានក្រុម និងប្រធានសាខា។'
  //       },
  //       {
  //         duty: 'ផ្សព្វផ្សាយ និងចូលរួមសកម្មភាពសង្គមដូចជា ឥណទានផ្សារភ្ជាប់និងការអប់រំ សុខភាព និងការការពារបរិស្ថាន ព្រមទាំងជួយប្រឹក្សាយោបល់បង្កើនមុខរបររបស់អតិថិជនតាមរយៈគំរូអជីវកម្មល្អ និងជោគជ័យ។'
  //       },
  //       {
  //         duty: 'បំពេញកិច្ចការងារផ្សេងៗទៀតត្រូវបានកំណត់ដោយ ប្រធានក្រុមមន្រ្តីឥណទាន ឬក៏ប្រធានសាខា។'
  //       }
  //     ],
  //     competencies: [
  //       {
  //         competency: 'បានប្រឡងជាប់សញ្ញាបត្របាក់ឌុប ឬបរិញ្ញាបត្រកាន់តែប្រសើរ។'
  //       },
  //       {
  //         competency: 'មានបទពិសោធន៍យ៉ាងតិច ២ឆ្នាំទាក់ទងនឹងវិស័យធនាគារ ឬមីក្រូហិរញ្ញវត្ថុ។'
  //       },
  //       {
  //         competency: 'ពូកែខាងគណិតវិទ្យា និងមានជំនាញគណនាល្អ។'
  //       },
  //       {
  //         competency: 'មានជំនាញក្នុងការផ្តល់សេវាកម្មល្អ ការទំនាក់ទំនងល្អ និងការដោះស្រាយបញ្ហា។'
  //       },
  //       {
  //         competency: 'មានសីលធម៌ល្អ មានឥរិយាបថល្អ មានភាពស្មោះត្រង់ មានការប្តេជ្ញាចិត្តខ្ពស់ មានការគោរពវិន័យ និងអាចធ្វើការជាក្រុមបាន។'
  //       },
  //       {
  //         competency: 'អាចធ្វើការក្រោមសម្ពាធបាន។'
  //       },
  //       {
  //         competency: 'មានឆន្ទៈក្នុងការរៀនអ្វីដែលថ្មីៗ និងរៀនឆាប់រហ័ស។'
  //       }
  //     ]
  //   }
  // ];


}
